import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { reactive, onBeforeMount, onBeforeUnmount } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'IntersectionObserverVue',
  props: {
    observeOnce: {
      type: Boolean,
      default: true
    },
    skip: {
      type: Boolean,
      default: false
    },
    threshold: {
      default: 0
    }
  },
  emits: ["intersection"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var states = reactive({
      observer: null,
      root: null,
      isVisible: false
    });
    // eslint-disable-next-line no-undef
    var onElementObserved = entries => {
      entries.forEach(_ref2 => {
        var {
          target,
          isIntersecting
        } = _ref2;
        if (isIntersecting) {
          states.isVisible = true;
          emits("intersection");
        }
        if (props.observeOnce && isIntersecting) unobserveTarget(target);
      });
    };
    var unobserveTarget = target => {
      if (!states.observer) return;
      states.observer.unobserve(target);
    };
    var disconnectObserver = () => {
      if (!states.observer) return;
      states.observer.disconnect();
    };
    onBeforeMount(() => {
      if (props.skip) {
        states.isVisible = true;
        return;
      }
      states.observer = new IntersectionObserver(onElementObserved, {
        root: null,
        //if the root is null, then we will check if the target is visible in the doc root!
        threshold: props.threshold
      });
    });
    onBeforeUnmount(() => {
      disconnectObserver();
    });
    return (_ctx, _cache) => {
      return !_unref(states).isVisible ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "root",
        class: _normalizeClass(_ctx.$attrs['root-classes'])
      }, [_renderSlot(_ctx.$slots, "observer", {
        observer: _unref(states).observer,
        isVisible: _unref(states).isVisible
      })], 2 /* CLASS */)) : _renderSlot(_ctx.$slots, "observer", {
        key: 1,
        observer: _unref(states).observer,
        isVisible: _unref(states).isVisible
      });
    };
  }
});